import {atom} from 'recoil';

export const msalTokenAtom = atom({
    key: 'msalTokenAtom',
    default: null,
})

export const oAuthTokenAtom = atom({
    key: 'oAuthTokenAtom',
    default: null,
})

export const userNodeSessionAtom = atom({
    key: 'userNodeSessionAtom',
    default: null,
})

export const userDetailsAtom = atom({
    key: 'userDetailsAtom',
    default: null,
})
 export const adGroupAtom = atom({
    key: 'adGroupAtom',
    default: null,
});

export const userPridAtom = atom({
  key: 'userPridAtom',
  default: null,
});

export const darkModeAtom = atom({
  key: 'darkModeAtom',
  default: false,
})

export const contentModalAtom = atom({
  key: 'contentModalAtom',
  default: { isOpen: false, contentType: null },
})


export const currentAssistantAtom = atom({
  key: 'currentAssistant',
  default: 'az', // Default to brand assistant
});


export const currentAppNameAtom = atom({
  key: 'currentAppNameAtom',
  default: null,
});

export const userAppListAtom = atom({
  key: 'userAppListAtom',
  default: [],
})

export const currentAppTheme = atom({
  key: 'currentAppTheme',
  default: 'az', // Default to brand assistant
});

export const currentUserIdAtom = atom({
  key: 'currentUserIdAtom',
  default: null,
});
 
export const currentAppConfigAtom = atom({
  key: 'currentAppConfigAtom',
  default: null,
});

export const currentContentPagesAtom = atom({
  key: 'currentContentPagesAtom',
  default: [],
});

export const currentAppQuickPromptsAtom = atom({
  key: 'currentAppQuickPromptsAtom',
  default: [],
})

export const appSwitchLoaderAtom = atom({
  key: 'appSwitchLoaderAtom',
  default: false,
})

export const isAdminAtom = atom({
    key: 'isAdminAtom',
    default: false,
})

export const loginFailureAtom = atom({
  key: 'loginFailureAtom',
  default: { isOpen: false, message: '' }
});

export const contentTabsAtom = atom({
  key: 'contentTabsAtom',
  default: [],
});